import * as React from "react";

interface DropToggleProps {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<EventTarget, MouseEvent>) => void;
}

const DropToggleButtonFRef = React.forwardRef<any, DropToggleProps>(
  (props, ref) => {
    return (
      <button
        ref={ref}
        className="dtime-pick-toggle"
        onClick={(e) => {
          e.preventDefault();
          if (props.onClick) {
            props.onClick(e);
          }
        }}
      >
        {props.children}
      </button>
    );
  }
);
export default DropToggleButtonFRef;
